import { IRequesterInfo } from '../../../base/models'
import { ClientProxy } from '../../../base/proxy/clientProxy'
import { IProduct } from '../models/response/getProductListResponseModel'

export class GetListProductsByBrandAndProductGroupApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'product/listProductsByBrandAndProductGroup',
      requesterInfo,
    })
  }

  public async getListProductsByBrandAndProductGroup(categoryId: string, brandId: string): Promise<IProduct[]> {
    this.props.url = `${this.props.url}?bId=${brandId}&cId=${categoryId}`

    return await this.getAsync<IProduct[]>()
  }
}
